import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, {
    "data-cy": "promo-card",
    class: "promo-card my-0 mx-0"
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "promo-background" }, null, -1)),
      _createVNode(_component_ion_row, { class: "ion-justify-content-center ion-align-items-center ion-text-center full-height" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, { class: "ion-margin-horizontal px-8 text-capitalize" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}